import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Element, scroller } from "react-scroll";
import {
  Title,
  SubTitle,
  BoxSchoolName,
  Radio,
  BlackLine,
  BoxActions,
  ButtoPayment,
  ButtoDownload,
  ColCentered,
  ColSpaced,
  BodyCardAtheletes,
  ParticipantName,
  DivInfos,
  Section,
  Label,
  ContentBox,
  ImgIcon,
  HeaderTitle
} from "./styles";
import { scrollTo, objectHasAnyKeys, objectHasAllKeys } from '../../../helpers/generalHelpers';
import FormInput from "components/core/FormInput";
import FormSelect from "components/core/FormSelect";
import Payment from "components/Payment";
import { Formik } from "formik";
import * as yup from "yup";
import axios from "axios";
import Keys from "utils/constants/keys";
import pagarme from "pagarme";
import ModalSchool from "components/Forms/School/Modal";
import { connect } from "react-redux";
import { basePath } from "../../../utils/constants/urlsAPI"
import { ReactComponent as Player } from "../../../assets/img/player_primary.svg";
import {
  cpfMask,
  weightMask,
  heightMask,
  phoneMask,
  zipCode
} from "../../../helpers/maskHelpers";

const School = ({
  countries,
  event,
  atheleteRequest,
  ref,
  athelete,
  schools
}) => {
  const initialValues = {
    address: "",
    birthday: "",
    city: "",
    complement: "",
    country: "32",
    email: "",
    europeanPassport: false,
    europeanPassportNumber: "",
    height: "",
    name: "",
    neighborhood: "",
    number: "",
    passport: "",
    phone: "",
    position: "",
    sex: "0",
    state: "",
    weight: "",
    zipCode: "",
    CPF: "",
    creditCardName: "",
    cardNumber: "",
    valid: "",
    numberPayment: "",
    cvv: "",
    eventId: event.event_id,
    cityId: event.address.number
  };
  const validationSchema = yup.object().shape({
    address: yup.string().required("Endereço é um campo obrigátorio"),
    birthday: yup
      .string()
      .required("Data de nascimento é um campo obrigátorio"),
    city: yup.string().required("Cidade é um campo obrigátorio"),
    complement: "",
    country: yup.string().required("País é um campo obrigátorio"),
    email: yup.string().email("O e-mail não é válido").required("E-mail é um campo obrigátorio"),
    europeanPassport: yup
      .string()
      .required("Informe caso tenha ou não passaporte"),
    europeanPassportNumber: yup
        .string()
        .when("europeanPassport", (europeanPassport, valueRequired) =>
          europeanPassport == "true"
            ? valueRequired.required("Titular é um campo obrigátorio")
            : valueRequired
    ),
    height: yup.string().required("Altura é um campo obrigátorio"),
    name: yup.string().required("Nome é um campo obrigátorio"),
    neighborhood: yup.string().required("Bairro é um campo obrigátorio"),
    number: yup.string().required("Número é um campo obrigátorio"),
    passport: yup.string()
    .when(["passportResp", "country"], (passportResp, country, valueRequired) =>
      ((minor && !passportResp) || !minor) && country != "32"
      ? valueRequired.required("Passaporte é um campo obrigátorio")
      : valueRequired
    ),
    phone: yup.string().required("Telefone é um campo obrigátorio"),
    position: yup.string().required("Posição é um campo obrigátorio"),
    sex: yup.string().required("Sexo é um campo obrigátorio"),
    state: yup.string().required("Estado é um campo obrigátorio"),
    weight: yup
      .string()
      .max(4, "Valor deve ter no máximo 3 numeros")
      .required("Peso é um campo obrigátorio"),
    zipCode: yup.string().required("CEP é um campo obrigátorio"),
    CPF: yup.string()
    .when(["CPFResp", "country"], (CPFResp, country, valueRequired) =>
      ((minor && !CPFResp) || !minor) && country == "32"
      ? valueRequired.required("CPF é um campo obrigátorio")
      : valueRequired
    ),
    creditCardName: yup
      .string()
      .when("paymentType", (payment, valueRequired) =>
        payment === "boleto"
          ? valueRequired
          : valueRequired.required("Titular é um campo obrigátorio")
      ),
    cardNumber: yup
      .string()
      .when("paymentType", (payment, valueRequired) =>
        payment === "boleto"
          ? valueRequired
          : valueRequired.required("Numero do cartão é um campo obrigátorio")
      ),
    valid: yup
      .string()
      .when("paymentType", (payment, valueRequired) =>
        payment === "boleto"
          ? valueRequired
          : valueRequired.required("Validade é um campo obrigátorio")
      ),
    numberPayment: yup
      .string()
      .when("paymentType", (payment, valueRequired) =>
        payment === "boleto"
          ? valueRequired
          : valueRequired.required("Parcelas é um campo obrigátorio")
      ),
    cvv: yup
      .string()
      .when("paymentType", (payment, valueRequired) =>
        payment === "boleto"
          ? valueRequired
          : valueRequired.required("CVV é um campo obrigátorio")
      )
  });
  const [minor, setMinor] = useState(false);
  const [initialPayment, setInitialPayment] = useState("")
  const [canParticipate, setCanParticipate] = useState(true);
  const [schoolId, setSchoolId] = useState(null);
  const [nextStep, setNextStep] = useState(false);
  const [partner, setPartner] = useState(false);
  const [participants, setParticipant] = useState([]);
  const [checked, setChecked] = useState(false);
  const requestZipCode = (cep, setFieldValue) => {
    if (cep.length >= 8) {
      axios
        .get(`https://admin.witsoccer.com/api/v1/find_cep?cep=${cep.substring(0, 8)}`)
        .then(response => {
          setFieldValue("address", response.data.address.street);
          setFieldValue("country", response.data.address.country_id.toString());
          setFieldValue("neighborhood", response.data.address.neighborhood);
          setFieldValue("city", response.data.address.city_name);
          setFieldValue("state", response.data.address.uf_name);
        });
    }
  };

  const validAge = date => {
    if (date) {
      const year = date.split("-")[0];
      const currentYear = new Date().getFullYear();
      const age = currentYear - parseInt(year);
      if (parseInt(year) > 1000) {
        setMinor(age < 18);
        if (!(age <= event.age_max && age >= event.age_min)) {
          setCanParticipate(false);
          alert(
            `Este evento é para idades entre ${event.age_min} e ${event.age_max} anos`
          );
        } else {
          setCanParticipate(true);
        }
      }
    }
  };

  const closeDialogShowForm = () => {
    setNextStep(false);
  };

  const defineSchoolName = id => {
    if (id === "0") {
      return "Escolinha não parceira";
    } else {
      const name = schools.schools.find(e => e.id == id);

      if (name) {
        return name.name;
      }
      return "Escolinha não parceira";
    }
  };

  const requestSchoolAtheletes = id => {
    setSchoolId(id);
    let endPointAtheletes = `${basePath}/api_web/school_athletes/event/${event.event_id}/school/${id}`;
    axios.get(endPointAtheletes).then(response => {
        const { data } = response;
        setParticipant(data.participants);
      });
  };

  useEffect(() => {
    requestSchoolAtheletes(schoolId);
  }, [athelete]);

  return (
    <>
      {!(schoolId && nextStep) && (
        <Section>
          <Container style={{ marginTop: "1em", marginBottom: "1em" }}>
            <Row>
              <Col md="12">
                <FormSelect
                  type="text"
                  label="Escolinha parceira:"
                  id="name"
                  name="name"
                  onChange={e => {
                    requestSchoolAtheletes(e.target.value)
                    if (checked) {
                      setChecked(false)
                      setPartner(false)
                    }
                  }}
                >
                  <option>Selecione uma escolinha parceira</option>
                  {schools.schools.map(e => {
                    return <option value={e.id}>{e.name}</option>;
                  })}
                </FormSelect>
                <div style={{ display: "flex", alignItems: "center", marginBottom: "2em", marginRight: "7.5px", marginLeft: "7.5px" }}>
                  <div>
                    <input
                      onClick={() => {
                        if (schoolId && schoolId !== "Selecione uma escolinha parceira") {
                          setChecked(false)
                          setPartner(false)
                        } else if (!schoolId || schoolId === "Selecione uma escolinha parceira") {
                          setChecked(check => !check)
                          setPartner(value => !value)
                        }
                      }}
                      type="radio"
                      id="partner"
                      values={checked}
                      checked={checked}
                    />
                  <Radio for="partner" style={{marginLeft: "5px"}}>Não sou parceiro</Radio>
                  </div>
                  <br />
                </div>
              </Col>
            </Row>
            <BlackLine />
            <BoxActions style={{ marginTop: "25px" }}>
              <ButtoPayment onClick={partner ? () => {
                setSchoolId(null)
                setNextStep(true)
              } : () => {
                setPartner(false)
                if (schoolId && schoolId !== "Selecione uma escolinha parceira") setNextStep(true)
              }} type="submit">
                <p>Continuar</p>
              </ButtoPayment>
            </BoxActions>
          </Container>
        </Section>
      )}

      {schoolId && nextStep && (
        <>
          <BoxSchoolName>
            <Container>
              <Row>
                <Col sm="12">
                  <h2 style={{fontWeight: "600", color: "#363636"}}>Escolinha parceira:</h2>
                  <h1>{defineSchoolName(schoolId)}</h1>
                </Col>
              </Row>
            </Container>
          </BoxSchoolName>
          <Container>
            <Row>
              <Col sm="12">
                <Title ref={ref}>
                  BEM-VINDA! Inscreva seus atletas e alunos de uma só vez! É rápido,
                  fácil e seguro!
                </Title>
                <SubTitle>
                  Basta clicar em adicionar atleta e seguir os passos.
                </SubTitle>
              </Col>
            </Row>
          </Container>
          {participants.map(e => {
            return (
                <BodyCardAtheletes>
                  <Container style={{margin: "auto"}}>
                    <Row>
                      <ColSpaced sm="12" md={{span: "6", offset: "2"}}>
                        <Player style={{marginRight: "10px"}} />
                        <ParticipantName>{e.name}</ParticipantName>
                      </ColSpaced>
                      <ColSpaced sm="12" md="4">
                        {e.boleto_url && (
                          <a target="_blank" href={e.boleto_url}>
                            <ButtoDownload
                              type="submit"
                              backgroundColor="transparent"
                              pcolor="#33393d"
                              width="auto"
                              >
                              <p style={{fontFamily: "Open Sans,sans-serif", lineHeight: "0px"}}>DOWNLOAD BOLETO</p>
                            </ButtoDownload>
                          </a>
                        )}
                      </ColSpaced>
                    </Row>
                  </Container>
                </BodyCardAtheletes>
            );
          })}
          <ContentBox>
            <Container style={{ marginBottom: "1em" }}>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values, {setValues, resetForm, setSubmitting}) => {
                  if (canParticipate) {
                    pagarme.client
                    .connect({ encryption_key: Keys.Pagarme_productionKey })
                    .then(client => {
                      return client.security.encrypt({
                        card_number: values.cardNumber.substring(0, 19),
                        card_holder_name: values.creditCardName,
                        card_expiration_date: values.valid.substring(0, 5),
                        card_cvv: values.cvv.substring(0, 3)
                      });
                    })
                    .then(cardHash => {
                      atheleteRequest({
                        ...values,
                        cardHash,
                        scroll: "subevents-form",
                        soccer_school_id: schoolId,
                        callback: () => {
                          setValues(initialValues)
                          setSubmitting(false)
                          scrollTo("subevents-form")
                          resetForm()
                          setInitialPayment(new Date().getTime())
                        }
                      });
                      return cardHash;
                    });
                  } else {
                    alert(
                      `Este evento é para idades entre ${event.age_min} e ${event.age_max} anos`
                    );
                  }
                }}
                >
                {props => {
                  const {
                    values,
                    touched,
                    errors,
                    isSubmitting,
                    handleChange,
                    resetForm,
                    setFieldValue,
                    setValues,
                    handleBlur,
                    setSubmitting,
                    handleSubmit
                  } = props;
                  const scrollToSection = () => {
                    const firstFormValues = ["address", "birthday", "city", "complement", "country",
                      "email", "height", "name", "neighborhood", "number", "passport", "phone",
                      "position", "sex", "state", "weight", "zipCode", "CPF", "europeanPassportNumber"]
                    const secondFormValues = ["creditCardName", "cardNumber", "valid", "numberPayment",
                      "cvv"]
                      if (objectHasAllKeys(firstFormValues, touched) && objectHasAnyKeys(firstFormValues, errors)) {
                        scrollTo("subevents-form")
                      } else if (objectHasAllKeys(secondFormValues, touched) && objectHasAnyKeys(secondFormValues, errors)) {
                        scrollTo("athlete-payment")
                      }
                  }
                  if (isSubmitting) {
                    scrollToSection()
                  }
                  return (
                    <>
                    <Row>
                      <Col md="5">
                        <FormInput
                          type="text"
                          id="name"
                          name="name"
                          value={values.name || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isError={errors.name && touched.name}
                          error={errors.name}
                          >
                          Nome completo:
                        </FormInput>
                      </Col>
                      <Col md="4">
                        <FormInput
                          type="text"
                          id="email"
                          name="email"
                          value={values.email || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isError={errors.email && touched.email}
                          error={errors.email}
                          >
                          Email:
                        </FormInput>
                      </Col>
                      <Col md="3">
                        <FormInput
                          type="text"
                          id="birthday"
                          name="birthday"
                          value={values.birthday || ""}
                          onChange={e => {
                            handleChange(e);
                            validAge(e.target.value);
                          }}
                          onBlur={handleBlur}
                          isError={errors.birthday && touched.birthday}
                          error={errors.birthday}
                          type="date"
                          >
                          Data de Nascimento:
                        </FormInput>
                      </Col>
                    </Row>
                    <Row>
                      <Col md="3">
                        <FormSelect
                          label="Sexo:"
                          id="sex"
                          name="sex"
                          value={values.sex || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isError={errors.sex && touched.sex}
                          error={errors.sex}
                          >
                          <option selected={values.sex === ""}></option>
                          <option value="female" selected={values.sex === "female"}>Feminino</option>
                          <option value="male" selected={values.sex === "male"}>Masculino</option>
                        </FormSelect>
                      </Col>
                      <Col md="3">
                        <FormSelect
                          label="Posição:"
                          type="text"
                          id="position"
                          name="position"
                          value={values.position || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isError={errors.position && touched.position}
                          error={errors.position}
                          >
                          <option selected={values.position === ""}></option>
                          {event.positions.map(e => {
                            return (
                              <option value={e.position_id} selected={values.position === e.position_id}>
                                {e.position_name}
                              </option>
                            );
                          })}
                        </FormSelect>
                      </Col>
                      <Col md="3">
                        <FormInput
                          type="text"
                          id="height"
                          name="height"
                          value={heightMask(values.height) || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isError={errors.height && touched.height}
                          error={errors.height}
                          >
                          Altura:
                        </FormInput>
                      </Col>
                      <Col md="3">
                        <FormInput
                          type="text"
                          id="weight"
                          name="weight"
                          value={weightMask(values.weight) || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isError={errors.weight && touched.weight}
                          error={errors.weight}
                          >
                          Peso(kg):
                        </FormInput>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={!minor ? "12" : "6"}>
                        <FormInput
                          type="tel"
                          id="phone"
                          name="phone"
                          value={phoneMask(values.phone) || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isError={errors.phone && touched.phone}
                          error={errors.phone}
                          >
                          Telefone do atleta:
                        </FormInput>
                      </Col>
                      {minor && (
                        <Col md={"6"}>
                          <FormInput
                            type="tel"
                            id="phoneResp"
                            name="phoneResp"
                            value={phoneMask(values.phoneResp) || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.phoneResp && touched.phoneResp}
                            error={errors.phoneResp}
                            >
                            Telefone do responsavel:
                          </FormInput>
                        </Col>
                      )}
                    </Row>
                    {values.country  != "32" ? (
                      <Row>
                        <Col md={!minor ? "12" : "6"}>
                          <FormInput
                            type="text"
                            id="passport"
                            name="passport"
                            value={values.passport || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.passport && touched.passport}
                            error={errors.passport}
                            >
                            Passaporte do atleta:
                          </FormInput>
                        </Col>
                        {minor && (
                          <Col md={!minor ? "12" : "6"}>
                            <FormInput
                              type="text"
                              id="passportResp"
                              name="passportResp"
                              value={values.passportResp || ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isError={errors.passportResp && touched.passportResp}
                              error={errors.passportResp}
                              placeHolder={minor ? "*Caso não tenha CPF, favor inserir o CPF do responsável." : ""}
                              >
                              Passaporte do responsavel:
                            </FormInput>
                          </Col>
                        )}
                      </Row>
                    ) : (
                      <Row>
                        <Col md={!minor ? "12" : "6"}>
                          <FormInput
                            type="text"
                            id="CPF"
                            name="CPF"
                            value={cpfMask(values.CPF) || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.CPF && touched.CPF}
                            error={errors.CPF}
                            placeHolder="*Caso não tenha CPF, favor inserir o CPF do responsável."
                            >
                            CPF do atleta:
                          </FormInput>
                        </Col>
                        {minor && (
                          <Col md={"6"}>
                            <FormInput
                              type="text"
                              id="CPFResp"
                              name="CPFResp"
                              value={cpfMask(values.CPFResp) || ""}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isError={errors.CPFResp && touched.CPFResp}
                              error={errors.CPFResp}
                              >
                              CPF do responsavel:
                            </FormInput>
                          </Col>
                        )}
                      </Row>
                    )}

                    <Row>
                      <Col md="3">
                        <FormSelect
                          type="text"
                          label="País"
                          id="country"
                          name="country"
                          value={values.country || ""}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isError={errors.country && touched.country}
                          error={errors.country}
                          >
                          <option selected={values.country === ""}></option>
                          {countries.countries.map(e => {
                            return <option value={e.id} selected={values.country == e.id}>{e.name} </option>;
                            })}
                          </FormSelect>
                        </Col>
                        <Col md="4">
                          <FormInput
                            type="text"
                            id="zipCode"
                            label="CEP"
                            name="zipCode"
                            value={zipCode(values.zipCode) || ""}
                            onChange={e => {
                              requestZipCode(e.target.value, setFieldValue);
                              handleChange(e);
                            }}
                            onBlur={handleBlur}
                            isError={errors.zipCode && touched.zipCode}
                            error={errors.zipCode}
                            >
                            CEP:
                          </FormInput>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="4">
                          <FormInput
                            type="text"
                            id="address"
                            label="CEP"
                            name="address"
                            value={values.address || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.address && touched.address}
                            error={errors.address}
                            >
                            Endereço:
                          </FormInput>
                        </Col>
                        <Col md="2">
                          <FormInput
                            type="text"
                            id="number"
                            label="CEP"
                            name="number"
                            value={values.number || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.number && touched.number}
                            error={errors.number}
                            >
                            Numero:
                          </FormInput>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormInput
                            type="text"
                            id="complement"
                            label="CEP"
                            name="complement"
                            value={values.complement || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.complement && touched.complement}
                            error={errors.complement}
                            >
                            Complemento:
                          </FormInput>
                        </Col>
                        <Col md="6">
                          <FormInput
                            type="text"
                            id="neighborhood"
                            label="CEP"
                            name="neighborhood"
                            value={values.neighborhood || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.neighborhood && touched.neighborhood}
                            error={errors.neighborhood}
                            >
                            Bairro:
                          </FormInput>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="6">
                          <FormInput
                            type="text"
                            id="city"
                            label="CEP"
                            name="city"
                            value={values.city || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.city && touched.city}
                            error={errors.city}
                            >
                            Cidade:
                          </FormInput>
                        </Col>
                        <Col md="6">
                          <FormInput
                            type="text"
                            id="state"
                            name="state"
                            value={values.state || ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isError={errors.state && touched.state}
                            error={errors.state}
                            >
                            Estado:
                          </FormInput>
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <Label>Passaporte Europeu:</Label>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: "10px" }}>
                              <input
                                onChange={() =>
                                  setFieldValue("europeanPassport", true)
                                }
                                checked={values.europeanPassport}
                                id="sim"
                                type="radio"
                                name="europeanPassport"
                                />{" "}
                                <Radio for="sim">Sim</Radio>
                              </div>
                              <br />
                              <div>
                                <input
                                  onChange={() =>
                                    setFieldValue("europeanPassport", false)
                                  }
                                  checked={!values.europeanPassport}
                                  id="nao"
                                  type="radio"
                                  name="europeanPassport"
                                  />{" "}
                                  <Radio for="nao">Não</Radio>
                                </div>
                                <br />
                              </div>
                            </Col>
                            {values.europeanPassport && (<Col md="6">
                              <FormInput
                                type="text"
                                id="europeanPassportNumber"
                                name="europeanPassportNumber"
                                value={values.europeanPassportNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                isError={errors.europeanPassportNumber && touched.europeanPassportNumber}
                                error={errors.europeanPassportNumber}
                              >
                                Número do Passaporte:
                              </FormInput>
                            </Col>)}
                          </Row>
                          <Element name="athlete-payment">
                            <Payment
                              addBtn
                              initialPayment={initialPayment}
                              values={values}
                              touched={touched}
                              errors={errors}
                              isSubmitting={isSubmitting}
                              handleChange={handleChange}
                              setFieldValue={setFieldValue}
                              handleBlur={handleBlur}
                              handleSubmit={handleSubmit}
                              event={event}
                              />
                          </Element>
                          </>
                      );
                    }}
                  </Formik>
                </Container>
          </ContentBox>
        </>
      )}
      {partner && nextStep && <ModalSchool
        closeDialogShowForm={closeDialogShowForm}
        modalIsOpen={partner && nextStep}
      />}
    </>
  );
};

const mapDispatchToProps = dispatch => ({});
const mapStateToProps = state => ({
  athelete: state.athelete
});

export default connect(mapStateToProps, mapDispatchToProps)(School);
